var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSingle = function SvgSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.53 17.65a8.2 8.2 0 0 1 7.266 4.401l7.658 16.632c.779 1.49.123 3.19-1.5 3.625a2.48 2.48 0 0 1-2.657-.93l-5.114-9.021v6.956l.036.08-.036.064v3.283c.282 2.505-1.157 3.994-3.21 5.133-1.159.645-3.944 2.145-6.673 2.06-2.104-.067-3.696-.925-5.76-2.06-2.334-1.281-3.71-3.137-3.71-5.133V31.945l-5.346 9.433a2.48 2.48 0 0 1-2.657.93c-1.623-.436-2.279-2.136-1.5-3.625l7.657-16.632a8.2 8.2 0 0 1 7.267-4.4ZM24.876.063a7.454 7.454 0 1 1 0 14.909 7.454 7.454 0 0 1 0-14.909Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

export default SvgSingle;